import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import { Typography } from '../Typography';
import type {
  StyledInfoboxContentProps,
  StyledInfoboxHeaderProps,
  StyledInfoboxRootProps,
} from './Infobox.types';

export const StyledInfoboxRoot = styled('div', {
  componentName: 'Infobox',
  slot: 'root',
})<StyledInfoboxRootProps>(
  () => {
    return {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 12,
      padding: 16,
      borderRadius: 8,
    };
  },
  ({ theme }) => ({
    variants: [
      {
        props: { variant: 'basic' },
        style: {
          border: `1px solid ${theme.palette.border.secondary}`,
          backgroundColor: theme.palette.bg.secondary,
          color: theme.palette.text.primary,
        },
      },
      {
        props: { variant: 'highlight' },
        style: {
          border: `1px solid ${theme.palette.secondary[400]}`,
          backgroundColor: theme.palette.secondary[50],
          color: theme.palette.secondary[600],
        },
      },
      {
        props: { variant: 'danger' },
        style: {
          border: `1px solid ${theme.palette.border.danger}`,
          backgroundColor: theme.palette.orange[50],
          color: theme.palette.text.danger,
        },
      },
    ],
  }),
  getAllStyledProps,
);

export const StyledInfoboxHeader = styled('div', {
  componentName: 'Infobox',
  slot: 'header',
})<StyledInfoboxHeaderProps>(() => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  };
}, getAllStyledProps);

export const StyledInfoboxContent = styled(Typography, {
  componentName: 'Infobox',
  slot: 'contnet',
})<StyledInfoboxContentProps>(({ theme }) => {
  return {
    ...theme.typography.caption.regular,
    color: theme.palette.text.secondary,
    whiteSpace: 'pre-wrap',
  };
});
